var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.142 11.151a.5.5 0 1 1 .717.697l-3.087 3.182a.5.5 0 0 1-.718 0l-3.087-3.182a.5.5 0 1 1 .717-.697l2.729 2.812 2.729-2.812z","fill":"currentColor"}));
}

Chevron.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = Chevron;

Chevron.default = Chevron;
